export class Action {
  actionId
  statusId
  subStatusId
  action
  navigate

  constructor(action = {}) {
    this.actionId = action.actionId ? String(action.actionId) : ''
    this.statusId = action.statusId ? String(action.statusId) : ''
    this.statusId = action.subStatusId ? String(action.subStatusId) : ''
    this.action = action.action ? String(action.action) : ''
    this.navigate = action.navigate ? String(action.navigate) : ''
  }
}